export const MEDICAL_ITEM_DEFINITIONS = Object.freeze([
    {
        id: "medical.bandage",
        name: "STERILE BANDAGE",
        description: "A sealed roll of clean medical gauze.",
        category: "MEDICAL",
        tags: ["MEDICAL", "FABRIC", "SEALED"],
        stackLimit: 10,
        unitMassGrams: 45,
        volumeMl: 95,
        longestDimensionMm: 75,
        iconKey: "medical",
        worldAssetId: "cloth_bundle",
        scarcity: "UNCOMMON",
        sortOrder: 30,
    },
    {
        id: "medical.antiseptic_wipes",
        name: "ANTISEPTIC WIPES",
        description: "Several unopened disinfectant wipes.",
        category: "MEDICAL",
        tags: ["MEDICAL", "FABRIC", "SEALED"],
        stackLimit: 20,
        unitMassGrams: 12,
        volumeMl: 12,
        longestDimensionMm: 85,
        iconKey: "medical",
        worldAssetId: "pickup_bundle",
        scarcity: "UNCOMMON",
        sortOrder: 31,
    },
]);
